import React, { memo, useMemo } from 'react';
import { Table, TableColumn, TableAddon } from 'tea-component';
import Loading from '@gp/components/Loading';
import NoData from '@gp/components/NoData';
import { getColumns, generateDates } from './utils/common';
import './index.scss';

const { autotip, scrollable } = Table.addons;

const LOADING = false;

interface MergeableTableProps extends IBaseProps {
  module?: 'revenue' | 'profit';
  loading: boolean;
  // 筛选器选择的日期
  date: string;
  // studio下 project的总数
  total: number;
  data: IBudgetActualOrForecastCompleteTableData[];
}

function MergeableTable(props: MergeableTableProps) {
  const { module, loading, date, total, data } = props;

  const columns = useMemo<
    TableColumn<IBudgetActualOrForecastCompleteTableData>[]
  >(() => {
    const dates = generateDates(date);
    return getColumns(module, dates, total);
  }, [module, date, total]);

  const records = useMemo<IBudgetActualOrForecastCompleteTableData[]>(() => {
    if (!Array.isArray(data)) return [];
    return data?.map((item, i) => ({
      ...item,
      uniqueId: i,
    }));
  }, [data]);

  // 表格使用到的插件
  const addons = useMemo<TableAddon[]>(() => {
    return [
      scrollable({
        // maxHeight: 238,
      }),
      autotip({
        isLoading: LOADING,
        hideIcon: !LOADING, //loading状态显示图标，其他情况不显示
        emptyText: <span style={{ color: '#444' }}>No data yet.</span>,
        style: {
          height: 172,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          boxSizing: 'border-box',
          margin: '0 auto',
        },
      }),
    ];
  }, []);

  return (
    <section className="revenue-completion-content">
      {loading && <Loading loading style={{ height: 260 }} />}
      {!loading && !records?.length && (
        <NoData height={200} constomStyle={{ fontSize: 14 }} />
      )}
      {!loading && records?.length > 0 && (
        <Table
          className="dbg-common-table revenue-completion-list-table"
          // verticalTop
          bordered="all"
          recordKey="uniqueId"
          columns={columns}
          addons={addons}
          records={records}
        />
      )}
    </section>
  );
}

MergeableTable.defaultProps = {
  module: 'revenue',
  loading: true,
  data: null,
  date: '',
  total: 0,
};

export default memo(MergeableTable);
